export default __webpack_public_path__ + "static/media/nutrionist@2x.dad7e363.png";